// extracted by mini-css-extract-plugin
export default {"right-button":"update-password_right-button__YF-ny","button":"update-password_button__ez7-a","buttons":"update-password_buttons__Wg616"};